<template>
  <div>
    <div style="display: inline">
      <badge :type="getDeliveryBadgeType()">
        {{ $t(`PROPERTIES_COLLECTIONS.PROPERTIES_STATUS_${property.status}`) }}
      </badge>
    </div>
  </div>
</template>

<script>
import {
  STATUS_WAITING_PAYMENT,
  STATUS_PARTIAL_PAYMENT,
  STATUS_PAIED,
  STATUS_APPROVED,
} from "@/constants/properties";

export default {
  name: "property-status-badge-component",

  components: {},

  mixins: [],

  props: ["property"],

  data() {
    return {};
  },

  computed: {},

  methods: {
    getDeliveryBadgeType() {
      switch (this.property.status) {
        case STATUS_APPROVED:
          return "success";
        case STATUS_WAITING_PAYMENT:
          return "primary";
        case STATUS_PARTIAL_PAYMENT:
          return "warning";
        case STATUS_PAIED:
          return "yellow";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
